import * as React from 'react';

import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

import { easeTransition } from '@components/framer';

export interface CircleArrowIconProps {
  className?: string;
  arrowUp?: boolean;
  size?: string;
  customBgColor?: boolean;
  darkCustomBgColor?: boolean;
  isDark?: boolean;
  isWhite?: boolean;
  smallArrow?: boolean;
  disabled?: boolean;
  onClick?: (ev: React.MouseEvent<SVGSVGElement, MouseEvent>) => void;
}

export const CircleArrowIcon: React.FC<CircleArrowIconProps> = (props) => {
  const arrowDirection = {
    down: {
      rotate: 0,
      transition: {
        ...easeTransition,
        duration: 0.25,
      },
    },
    up: {
      rotate: 180,
      transition: {
        ...easeTransition,
        duration: 0.25,
      },
    },
  };

  return (
    <svg
      width={props.size ? props.size : '18px'}
      height={props.size ? props.size : '18px'}
      viewBox="0 0 18 18"
      className={props.className}
      preserveAspectRatio="none"
      onClick={(ev) =>
        props.onClick && !props.disabled ? props.onClick(ev) : null
      }
    >
      <motion.g
        variants={arrowDirection}
        initial="down"
        animate={props.arrowUp ? 'up' : 'down'}
      >
        <StyledCircle
          cx="9"
          cy="9"
          r="9"
          className={`${props.isDark ? 'dark' : ''} ${
            props.isWhite ? 'white' : ''
          } ${props.arrowUp ? 'arrow-up' : ''}`}
        />
        <StyledPath
          className={`${props.isDark ? 'dark' : ''}  ${
            props.isWhite ? 'white' : ''
          } ${props.arrowUp ? 'arrow-up' : ''} ${
            props.smallArrow ? 'small' : ''
          }`}
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          d="M6,7.5l3,3l3-3"
        />
      </motion.g>
    </svg>
  );
};

export default styled(CircleArrowIcon)`
  cursor: pointer;

  ${(props) =>
    props.size &&
    css`
      width: ${props.size};
      height: ${props.size};
    `}

  ${(props) =>
    props.disabled
      ? css`
          cursor: auto;
          pointer-events: none;
          opacity: 0.5;
        `
      : null}

  ${(props) =>
    props.customBgColor
      ? css`
          circle {
            fill: ${({ theme }) => theme.colors.iconBackground};
          }
        `
      : null}
  ${(props) =>
    props.darkCustomBgColor
      ? css`
          circle {
            fill: ${({ theme }) => theme.colors.secondaryHover};
          }
        `
      : null}
`;

const StyledCircle = styled.circle`
  fill: ${({ theme }) => theme.colors.box};
  transition: fill
    ${({ theme }) => `${theme.transitions.duration} ${theme.transitions.type}`};

  &.dark {
    fill: ${({ theme }) => theme.colors.blackActive};
  }

  &.white {
    fill: ${({ theme }) => theme.colors.differentBackground};
    &:hover {
      fill: ${({ theme }) => theme.colors.secondaryHover};
    }
  }
`;

const StyledPath = styled.path`
  stroke: ${({ theme }) => theme.colors.primary};

  &.dark {
    stroke: ${({ theme }) => theme.colors.white};
  }

  &.white {
    &:hover {
      stroke: ${({ theme }) => theme.colors.black};
    }
  }

  &.small {
    transform: scale(0.75);
    transform-origin: center center;
  }
`;
